import { useInfiniteQuery } from "@tanstack/react-query";
import { getVehicleAssignments } from "../services";

export const VEHICLE_ASSIGNMENTS_QUERY_KEY = "vehicle-assignments";

export const useInfiniteVehicleAssignments = (
	vehicleId: string,
	pageSize: number,
	enabled = true
) =>
	useInfiniteQuery({
		queryKey: [VEHICLE_ASSIGNMENTS_QUERY_KEY, vehicleId, "infinite", pageSize],
		queryFn: ({ pageParam }) =>
			getVehicleAssignments(vehicleId, { pageNumber: pageParam, pageSize }),
		initialPageParam: 1,
		getNextPageParam: (lastPage) =>
			lastPage.currentPage < lastPage.totalPages
				? lastPage.currentPage + 1
				: undefined,
		enabled: enabled && !!vehicleId,
	});
